export default function Footer() {
     return(
          <footer className = "footer-section">
               <p className = "footer-text">
               &copy; {new Date().getFullYear()} Alive Gardens. All rights reserved.
               </p>
               <p className = "footer-text">
                    Created by Kevin Aparicio
               </p>
          </footer>
     );
}